/**
 * Created by mgoria on 1/20/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogDriverException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base exception
 */
let LogDriverException = exports.LogDriverException = function (_Exception) {
  _inherits(LogDriverException, _Exception);

  /**
   * @param {Array} args
   */
  function LogDriverException() {
    var _ref;

    _classCallCheck(this, LogDriverException);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = LogDriverException.__proto__ || Object.getPrototypeOf(LogDriverException)).call.apply(_ref, [this].concat(args)));
  }

  return LogDriverException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/LogDriverException.js
// module id = 27
// module chunks = 0